<script lang="ts">
	export let customClass = '';
</script>

<div class="{customClass} mt-6 h-7 animate-pulse rounded-full bg-gray-200"></div>
